import { z } from "zod";
export const visibilityClasses = ["owner_private", "tenant_shared"];
export const processingStates = [
    "pending",
    "processing",
    "success",
    "partial",
    "unsupported",
    "failed",
    "inaccessible",
    "deleted",
];
export const knowledgeProcessingStates = [
    "pending",
    "processed_with_links",
    "processed_no_supported_claim",
    "partial",
    "failed",
];
export const claimStates = [
    "supported",
    "conflicted",
    "superseded",
    "uncertain",
];
export const identifierTypes = [
    "provider_object_id",
    "customer_number",
    "project_number",
    "quote_number",
    "order_number",
    "invoice_number",
    "contract_number",
    "uid_vat",
    "email_address",
    "phone_number",
    "iban",
    "domain",
    "name",
];
export const identifierStrengths = ["strong", "conditional", "weak"];
export const identifierStrengthByType = {
    provider_object_id: "strong",
    customer_number: "strong",
    project_number: "strong",
    quote_number: "strong",
    order_number: "strong",
    invoice_number: "strong",
    contract_number: "strong",
    uid_vat: "strong",
    email_address: "conditional",
    phone_number: "conditional",
    iban: "conditional",
    domain: "weak",
    name: "weak",
};
export const entityTypes = [
    "person",
    "company",
    "project",
    "quote",
    "order",
    "invoice",
    "contract",
    "document",
    "mailbox",
    "mail_thread",
    "source_item",
    "meeting",
];
export const relationTypes = [
    "belongs_to_project",
    "quote_for",
    "invoice_for",
    "sent_to",
    "authored_by",
    "reply_to",
    "attached_to",
    "decided",
    "committed_to",
    "payment_due",
    "delivery_delayed",
    "complains_about",
    "supersedes",
    "invited_to",
    "participated_in",
];
export const observedStateTypes = [
    "reply_observed",
    "commitment_open",
    "payment_observed",
    "source_coverage",
];
export const absenceCoverageStates = [
    "complete",
    "partial",
    "unknown",
];
export const providers = ["microsoft", "whatsapp"];
export const sourceKinds = [
    "email_message",
    "file_attachment",
    "item_attachment",
    "reference_attachment",
    "inline_attachment",
    "document",
    "calendar_event",
    "teams_message",
    "whatsapp_message",
    "drive_item",
    // The synthetic parent of a conversation rollup. It is the one source kind no
    // provider ever hands us: `provider_item_id` carries the window reference the
    // rollup was derived under, and it exists so a derived composition inherits a
    // real row's tenant, owner and visibility through the same composite foreign
    // key every other derivative uses. Appended at the end because the SQL enum is
    // widened by ALTER TYPE ... ADD VALUE (20260808170000) and
    // supabase/tests/database/static-self-check.mjs compares the two as an
    // ORDERED set.
    "conversation_window",
];
export const attachmentTypes = ["file", "item", "reference", "inline"];
export const sourceLifecycleStates = [
    "active",
    "deleted",
    "inaccessible",
];
// `not_applicable` is the only one of these that is not a stage of work: it says
// the item will never have a graph and that this is correct, not pending. A mail
// attachment in a format no reader claims (ZIP, RAR, XLSX today) can never hold
// canonical text, so it can never hold a graph either, and leaving it `pending`
// asserts queued work that nothing in the pipeline can ever perform. Held in
// lockstep with the app_private.graph_processing_status enum by
// supabase/tests/database/static-self-check.mjs, which compares the two as an
// ORDERED set — the SQL label is appended by ALTER TYPE ... ADD VALUE
// (20260726250000), so it belongs at the end here too.
export const graphProcessingStates = [
    "pending",
    "success",
    "partial",
    "failed",
    "not_applicable",
];
export const completenessStates = [
    "pending",
    "success",
    "partial",
    "unsupported",
    "failed",
];
// Graph change-notification (webhook) subscription lifecycle state. Operational,
// like graphProcessingStates: it is mirrored by the app_private.subscription_status
// enum (held in lockstep by supabase/tests/database/static-self-check.mjs) and is
// not part of the public controlled vocabulary. `pending` is set at create intent,
// `active` once Graph confirms the subscription, `expired` when its window lapses,
// `failed` on a create/renew error, and `removed` after an explicit delete or a
// subscriptionRemoved lifecycle event.
export const subscriptionStatuses = [
    "pending",
    "active",
    "expired",
    "failed",
    "removed",
];
export const visibilityClassSchema = z.enum(visibilityClasses);
export const processingStateSchema = z.enum(processingStates);
export const knowledgeProcessingStateSchema = z.enum(knowledgeProcessingStates);
export const claimStateSchema = z.enum(claimStates);
export const identifierTypeSchema = z.enum(identifierTypes);
export const identifierStrengthSchema = z.enum(identifierStrengths);
export const entityTypeSchema = z.enum(entityTypes);
export const relationTypeSchema = z.enum(relationTypes);
export const observedStateTypeSchema = z.enum(observedStateTypes);
export const absenceCoverageStateSchema = z.enum(absenceCoverageStates);
export const providerSchema = z.enum(providers);
export const sourceKindSchema = z.enum(sourceKinds);
export const attachmentTypeSchema = z.enum(attachmentTypes);
export const sourceLifecycleStateSchema = z.enum(sourceLifecycleStates);
export const graphProcessingStateSchema = z.enum(graphProcessingStates);
export const completenessStateSchema = z.enum(completenessStates);
export const subscriptionStatusSchema = z.enum(subscriptionStatuses);
//# sourceMappingURL=vocabulary.js.map